/**
 * 二维码工具（薄封装 node-qrcode，浏览器入口只依赖 dijkstrajs）。
 * 用法：import { renderQrToCanvas } from '@/utils/qrcode'
 */
import QRCode from 'qrcode/lib/browser.js'

/**
 * 把文本渲染成二维码画到 canvas。
 * @param {HTMLCanvasElement} canvas 目标画布
 * @param {string} text 文本（URL 等）
 * @param {object} opts 可选 { size=220, margin=2, level='M', dark='#000000', light='#ffffff' }
 * @returns {number} 实际渲染尺寸（px），文本超长抛 Error
 */
export function renderQrToCanvas (canvas, text, opts = {}) {
  const size = opts.size || 220
  const margin = opts.margin == null ? 2 : opts.margin
  const level = opts.level || 'M'
  canvas.width = size
  canvas.height = size
  const ctx = canvas.getContext('2d')
  ctx.clearRect(0, 0, size, size)
  if (!text) return size
  const qr = QRCode.create(text, { errorCorrectionLevel: level })
  const n = qr.modules.size
  const data = qr.modules.data
  const total = n + margin * 2
  const cell = Math.floor(size / total)
  const offset = Math.floor((size - cell * n) / 2)
  // 底色
  ctx.fillStyle = opts.light || '#ffffff'
  ctx.fillRect(0, 0, size, size)
  // 模块
  ctx.fillStyle = opts.dark || '#000000'
  for (let r = 0; r < n; r++) {
    for (let c = 0; c < n; c++) {
      if (data[r * n + c]) {
        ctx.fillRect(offset + c * cell, offset + r * cell, cell, cell)
      }
    }
  }
  return size
}

/**
 * 导出 PNG dataURL（下载用）。
 */
export function qrToDataURL (text, opts = {}) {
  return QRCode.toDataURL(text, {
    errorCorrectionLevel: opts.level || 'M',
    margin: opts.margin == null ? 2 : opts.margin,
    width: opts.width || 440,
    color: { dark: opts.dark || '#000000ff', light: opts.light || '#ffffffff' }
  })
}
